module.exports = __webpack_public_path__ + "img/coy.a8c2dd5b.svg";